module.exports = __webpack_public_path__ + "img/loan-dollar.6491a8ec.svg";